import { ValueOf } from "src/types.d"

export const RemoteConfigBanners = Object.freeze({
  Home: "home_campaign_banner",
  Renraku: "renraku_campaign_banner",
} as const)

export type RemoteConfigBanners = ValueOf<typeof RemoteConfigBanners>
